import { render, staticRenderFns } from "./newConsumeDetailed_bak.vue?vue&type=template&id=27d0d99c"
import script from "./newConsumeDetailed_bak.vue?vue&type=script&lang=js"
export * from "./newConsumeDetailed_bak.vue?vue&type=script&lang=js"
import style0 from "./newConsumeDetailed_bak.vue?vue&type=style&index=0&id=27d0d99c&prod&lang=stylus&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports